// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__14dAw","additionalInfo":"AgreementModal_additionalInfo__35c-q"};